import { render, staticRenderFns } from "./SurrenderRequestPop.vue?vue&type=template&id=137df34a&scoped=true"
import script from "./SurrenderRequestPop.vue?vue&type=script&lang=js"
export * from "./SurrenderRequestPop.vue?vue&type=script&lang=js"
import style0 from "./SurrenderRequestPop.vue?vue&type=style&index=0&id=137df34a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137df34a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('137df34a')) {
      api.createRecord('137df34a', component.options)
    } else {
      api.reload('137df34a', component.options)
    }
    module.hot.accept("./SurrenderRequestPop.vue?vue&type=template&id=137df34a&scoped=true", function () {
      api.rerender('137df34a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/SurrenderRequestPop.vue"
export default component.exports